import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./PurchaseRequest/Main";
import Form from "./PurchaseRequest/Form";

// Utils
import {
  getDataWithComp,
  getDocStatusColour,
  getAlert,
  getMaxDocNo2,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

function PurchaseRequest() {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [maxDocNo, setMaxDocNo2] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      console.debug("🔄 Fetching latest master list...");
      const masterList = await getDataWithComp(
        "API_0201_PO_H",
        "ORDER BY Doc_No DESC"
      );

      const docStatusColour = await getDocStatusColour("PO", "Doc_Status");

      if (masterList && masterList.length > 0) {
        const sortedData = masterList.sort((a, b) => a.Doc_Id - b.Doc_Id);
        setDataMasterList(sortedData);
      }

      if (docStatusColour && docStatusColour.length > 0) {
        setStatusColours(docStatusColour);
      }

      // ✅ รอให้ฐานข้อมูลอัปเดตก่อนดึงค่าใหม่
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // ✅ ดึงเลขล่าสุดใหม่
      const newDocNo = await getMaxDocNo2();
      console.debug("🚀 Final newDocNo to set:", newDocNo);
      setMaxDocNo2(newDocNo);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo2(docNo);
    setMode("U");
  };

  return (
    <div className="PurchaseRequest">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  detailList={dataDetailList}
                  statusColours={statusColours}
                  name={"ใบสั่งซื้อ"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(docNo) => onRowSelected(docNo)}
                  getReport={getReport}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ใบสั่งซื้อ"}
                  maxDocNo={maxDocNo}
                  setMaxDocNo2={setMaxDocNo2}
                  getReport={getReport}
                  masterList={dataMasterList}
                  setMode={setMode}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PurchaseRequest;
